export const initialFormData = {
  Doc_No: "",
  supplyType: "B2B",
  subType: "",
  docType: "INV",
  doc_date: new Date().toISOString().split("T")[0],
  Company_Name_E: "",
  Address_E: "" || null,
  GST: "" || null,
  City_E: "",
  State_E: "",
  PIN: "",
  EmailId: "" || null,
  GSTRate: "",
  LESS_FRT_RATE: 0.0,
  LORRYNO: "",
  Buyer_Name: "",
  Buyer_Address: "" || null,
  BuyerGst_No: "" || null,
  Buyer_City: "",
  Buyer_State_Code: 0,
  Buyer_State_name: "",
  Buyer_Phno: "" || null,
  Buyer_Email_Id: "" || null,
  Buyer_State_name: "",
  Buyer_Pincode: "",
  System_Name_E: "",
  Mode_of_Payment: "",
  ShipToGst_No: "" || null,
  ShipTo_Address: "",
  ShipTo_City: "",
  ShipTo_GSTStateCode: 0,
  ShipTo_Name: "",
  ShipTo_Pincode: 0,
  itemDescription: "",
  HSN: "",
  NETQNTL: 0.0,
  unit: "QTL",
  taxableValue: 0.0,
  CGSTRate: 0.0,
  SGSTRate: 0.0,
  IGSTRate: 0.0,
  CGSTAmount: 0.0,
  SGSTAmount: 0.0,
  IGSTAmount: 0.0,
  DispatchCity_City: " ",
  DispatchGst_No: "" || null,
  Dispatch_Address: "",
  Dispatch_GSTStateCode: 0,
  GSTStateCode: 0,
  Dispatch_Name: "",
  Dispatch_Pincode: 0,
  Distance: 0,
  PHONE: "" || null,
  Account_Details: "",
  Branch: "",
  IsService: "N",
  TaxableAmount: 0.00,
  otherAmount: 0.00,
  billAmount: 0.00,
  transporterName: "" || null,
  transporterID: "" || null,
  approximateDistance: 0.00,
  tranceMode: "1",
  vehicleType: "R",
  rate: "",
  reverseCharge: "N",
  IGSTOnIntra: "N",
  cessValue: 0.0,
  discount: 0.0,
  payeeName: "" || null,
  cessAmount: 0.00,
  stateCessValue: 0.00,
  billFromAdd: "",
  BuyerAdd1: "",
  dispatchAdd: "",
  shipToAdd: "",
  pos: "",
  year: ""
};